export default __webpack_public_path__ + "static/media/permission-user.326b37db.svg";